import { Injectable } from '@angular/core';
import { ContextMenuTypes, IPC_CHANNELS } from '../../../../../electron-utils/electron.model';
import { ElectronService } from '../../../core/services';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  private _phoneNumberRegex = /^(\*[0-9]{1,})?(\+)?(([\.\-\/\\\(\)\s])?\d+)+([\.-\/\\\(\)\s]){0,1}$/

  constructor(private electronService: ElectronService) { }

  /**
   * If electron is present, open the page in the default browser
   * otherwise open the page in a new tab
   * @param {string} link Link to open
   */
  public openExternalLink(link: string): void {
    //if we are on electron, use electron to open the link on the default browser
    //otherwise use
    if (this.electronService.isElectron) {
      this.electronService.ipcRenderer.send(IPC_CHANNELS.OPEN_EXTERNAL_LINK, link);
    } else {
      window.open(link, '_blank');
    }
  }

  public detectBrowser() {
    var userAgent = navigator.userAgent;
    var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i};
    for(var key in browsers) {
        if (browsers[key].test(userAgent)) {
            return key;
        }
    };
    return 'unknown';
  }

  public copyToClipboard(value: string): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  public async copyToClipboardWithAPI(value: string): Promise<void> {
    try {
      navigator.clipboard.writeText(value);
    } catch(e) {
      throw e;
    }
  }

  public replaceExternalPopupKeys(externalLink: string, number: string) {
    return externalLink.replace(/\$\{CALLER_ID\}/g, number);
  }

  public getContextMenuType(event: MouseEvent) {
    const element = document.elementFromPoint(event.x, event.y);
    if(!element || element === document.documentElement) return null;
    return element.tagName === 'INPUT' ? ContextMenuTypes.input : ContextMenuTypes.selection;
  }

  public getTextSelected() {
    if(window.getSelection().type === 'Range' && window.getSelection().toString().length > 0) {
      return window.getSelection().toString();
    } else {
      return null;
    }
  }

  public pasteInPosition(original: string, pasteData: string, selectionStart: number, selectionEnd: number){
    if(typeof original !== 'string') original = '';
    return original.slice(0, selectionStart) +
           pasteData +
           original.slice(selectionEnd);
  }

  public isValidPhoneNumber(number: string): boolean {
    return this._phoneNumberRegex.test(number);
  }

  public get phoneNumberRegex(): RegExp {
    return this._phoneNumberRegex;
  }

  public cleanNumber(dirtyNumber: string): string {
    let startWithPlus: boolean = false;
    let cleanNumber = dirtyNumber;
    cleanNumber = cleanNumber.trim();
    cleanNumber = cleanNumber.replace(/[^\*\+\d]*/gm, '');
    return cleanNumber;
  }

  public contains = (val: any, text: string): boolean =>
    typeof val === 'string' && val.includes(text);
}
